import { request, Response } from '../utils';
import { Session } from '../types';

export const createSession = (body: {
  username: string;
  password: string;
}): Response<{ session: Session }> => request('create-session', body);
